import React from 'react';
import { connect } from 'react-redux';
import { setVariableCosts, setActiveTab } from '../actions/actions';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { Typography, Container, OutlinedInput, InputAdornment } from '@material-ui/core';

const ContentArea = styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
  margin: 16px;
  @media (min-width: 801px) {
    border-right: 1px solid #8080803d;
  };`;

const TabTitle = styled(Typography)`
  place-self: center;
  margin-right: 12px !important;
  margin-top: 16px !important;
`;

const BackButton = styled(Button)`
width: auto;
max-width: 800px;
justify-self: start;
align-self: center;
margin-left: 28px !important;
@media (max-width: 768px) {
  span {
    display: none;
  }
  :after {
    content: '<';
    font-size: 16px;
  }
}
`
const NavArea = styled.div`
display: grid;
grid-template-columns: auto auto;
`;


const NextButton = styled(Button)`
width: auto;
max-width: 800px;
justify-self: end;
align-self: center;
margin-right: 28px !important;
@media (max-width: 768px) {
  span {
    display: none;
  }
  :after {
    content: '>';
    font-size: 16px;
  }
}
`

const ResponsiveContainer = styled(Container)`
  margin: 24px;
}
`

const VariableCostsContainer = styled(Container)`
    margin: 12px;
    display: grid;
    grid-template-columns: 40% 40%;
    grid-template-rows: auto auto auto auto;
}
`

const MCInput = styled(OutlinedInput)`
  margin-top: 16px;
`



function TabContent(props) {
  const handleFocus = (event) => event.target.select();

  const handleTaxesChange = (event) => {
    props.setVariableCosts({ ...props.financialSetup.variableCosts, taxes: event.target.value })
  }

  const handleCardsChange = (event) => {
    props.setVariableCosts({ ...props.financialSetup.variableCosts, cards: event.target.value })
  }

  const handleComissionsChange = (event) => {
    props.setVariableCosts({ ...props.financialSetup.variableCosts, comissions: event.target.value })
  }

  return (
    <ContentArea>
      <TabTitle variant="h4">Despesas sobre vendas %</TabTitle>
      <VariableCostsContainer>
        <TabTitle variant="subtitle1">Impostos</TabTitle>
        <MCInput
          id="outlined-adornment-weight"
          startAdornment={<InputAdornment position="start">%</InputAdornment>}
          aria-describedby="outlined-weight-helper-text"
          value={props.financialSetup.variableCosts.taxes}
          onFocus={handleFocus}
          name="taxes"
          onChange={handleTaxesChange}
          inputProps={{
            'aria-label': 'weight',
          }}
        />
        <TabTitle variant="subtitle1">Cartões</TabTitle>
        <MCInput
          id="outlined-adornment-weight"
          startAdornment={<InputAdornment position="start">%</InputAdornment>}
          aria-describedby="outlined-weight-helper-text"
          value={props.financialSetup.variableCosts.cards}
          onFocus={handleFocus}
          name="cards"
          onChange={handleCardsChange}
          inputProps={{
            'aria-label': 'weight',
          }}
        />
        <TabTitle variant="subtitle1">Comissões</TabTitle>
        <MCInput
          id="outlined-adornment-weight"
          startAdornment={<InputAdornment position="start">%</InputAdornment>}
          aria-describedby="outlined-weight-helper-text"
          value={props.financialSetup.variableCosts.comissions}
          onFocus={handleFocus}
          name="comissions"
          onChange={handleComissionsChange}
          inputProps={{
            'aria-label': 'weight',
          }}
        />
      </VariableCostsContainer>
      <ResponsiveContainer>
        <Typography variant="h6">Ajuda</Typography>
        <Typography variant="body">São <b>despesas variáveis</b> que impactam diretamente no faturamento bruto. Caso tenha dúvidas, converse com seu contador sobre os impostos pagos sobre o faturamento.
          </Typography>
      </ResponsiveContainer>
      <NavArea>
        <BackButton
          variant="contained"
          onClick={() => props.setActiveTab(props.activeTab - 1)}
          color="secondary"
          disabled={props.financialSetup.revenue <= 0}
          startIcon={<NavigateBeforeIcon />}
        >
          Voltar
        </BackButton>
        <NextButton
          variant="contained"
          onClick={() => props.setActiveTab(props.activeTab + 1)}
          color="secondary"
          disabled={props.financialSetup.revenue <= 0}
          endIcon={<NavigateNextIcon />}
        >
          Próximo
        </NextButton>
      </NavArea>
    </ContentArea>
  );
}

const mapStateToProps = (state) => {
  return {
    financialSetup: state.reducers.financialSetup,
    activeTab: state.reducers.activeTab
  }
}

const mapDispatchToProps = { setVariableCosts, setActiveTab }
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabContent)
